import React from 'react';
import { motion } from 'framer-motion';
import { MapPin } from 'lucide-react';
const experienceData = [{
  company: 'Advantaclean of Hartford',
  location: 'Hartford, CT Area',
  initial: 'A',
  logo: 'https://www.google.com/s2/favicons?domain=advantaclean.com&sz=128',
  fallbackLogo: 'https://logo.clearbit.com/advantaclean.com',
  roles: [{
    title: 'Owner/Operator, Franchise',
    period: 'Jan 2011 — Aug 2025',
    description: 'Established and operated Light Environmental Services & Restoration franchise. Oversaw startups, marketing, and administration. Managed water damage restoration, project management, and customer retention. Developed construction capabilities.',
    achievements: ['Spearheaded franchise startup and operational management', 'Championed marketing strategies that enhance brand visibility', 'Drove customer retention initiatives, resulting in repeat business', 'Trained and supervised staff to ensure service excellence']
  }]
}, {
  company: 'Molly Maid of Greater Hartford',
  location: 'Hartford, CT Area',
  initial: 'M',
  logo: 'https://www.google.com/s2/favicons?domain=mollymaid.com&sz=128',
  fallbackLogo: 'https://logo.clearbit.com/mollymaid.com',
  roles: [{
    title: 'Owner/Operator, Franchise',
    period: 'Jan 2011 — Nov 2014',
    description: 'Managed daily residential cleaning services, overseeing 15-22 employees in a franchise setting. Implemented business and marketing strategies, achieving 25% growth over three years. Drove 15% average year-over-year sales growth. Successfully sold the business in 2014.',
    achievements: ['Expanded client base through targeted marketing initiatives', 'Enhanced operational efficiencies, improving service delivery', 'Cultivated a motivated team, fostering employee retention']
  }]
}, {
  company: 'Pratt & Whitney',
  location: 'East Hartford, CT',
  initial: 'P',
  logo: 'https://www.google.com/s2/favicons?domain=prattwhitney.com&sz=128',
  fallbackLogo: 'https://logo.clearbit.com/prattwhitney.com',
  roles: [{
    title: 'Project Controls Manager & Scheduler',
    period: 'Mar 2010 — Oct 2010',
    description: 'Oversaw design and development of an integrated scheduling system in Primavera, aligning with SAP budget and controls. Coordinated project schedules and reporting across engineering, accounting, and program management teams. Delivered comprehensive reporting, system administration, training materials, and standardized schedules.',
    achievements: ['Spearheaded integration of management tools to enhance project visibility', 'Streamlined communication between cross-functional teams, improving efficiency', 'Developed training materials, ensuring smooth system adoption across departments']
  }]
}, {
  company: 'Keystone Mechanical',
  location: 'Middletown, CT',
  initial: 'K',
  logo: '',
  fallbackLogo: '',
  roles: [{
    title: 'Scheduler',
    period: 'May 2009 — Feb 2010',
    description: 'Created project controls and schedules for Kleen Energy Systems combined cycle power plant using Primavera P3 5.0. Oversaw critical path analysis, engineering staffing, and change management. Enhanced budget management through precise reporting.',
    achievements: ['Spearheaded critical path analysis to optimize project timelines', 'Championed engineering staffing strategies to meet project demands', 'Drove change management processes for seamless project execution']
  }]
}, {
  company: 'P.S., Ltd.',
  location: 'New York, NY',
  initial: 'P',
  logo: '',
  fallbackLogo: '',
  roles: [{
    title: 'Management Consultant',
    period: 'Aug 2000 — Sep 2009',
    description: 'Oversee project management and controls, specializing in schedule engineering and implementation. Consult on Primavera P6 schedules, software development life cycle, work breakdown structures, reporting, logic, resource loading, and delay claims. Collaborated with clients including Uproar.com, Merrill Lynch, and AIG Insurance.',
    achievements: ['Advised on scheduling and reporting using Primavera P6', 'Enhanced software development programs through effective controls', 'Streamlined resource loading processes for various projects']
  }]
}, {
  company: 'Fluor Corporation',
  location: 'Multiple Locations',
  initial: 'F',
  logo: 'https://www.google.com/s2/favicons?domain=fluor.com&sz=128',
  fallbackLogo: 'https://logo.clearbit.com/fluor.com',
  roles: [{
    title: 'Scheduler (FLUOR Constructors)',
    period: 'May 2008 — Apr 2009',
    description: 'Developed detailed P3 schedules for BP High Sulfur Crude Plant upgrade, coordinating interconnects, piping, and electrical trades. Conducted critical path analysis for shutdowns, optimising schedules using Primavera P3 6.0 and Excel.',
    achievements: ['Created comprehensive turnaround schedules for mechanical construction', 'Improved project timelines through effective schedule integration', 'Enhanced workflow by coordinating multiple trades efficiently']
  }, {
    title: 'Scheduler (FLUOR Constructors)',
    period: 'Nov 2007 — Apr 2008',
    description: 'Oversaw scheduling activities for Sunoco Toledo Refinery Consent Decree Project using Primavera P3 6.0. Coordinated electrical, instrumentation, and mechanical shutdown planning. Controlled field installation work packages, ensuring compliance with PMP standards.',
    achievements: ['Enhanced project timelines by implementing strategic scheduling techniques', 'Improved communication between teams for effective schedule coordination', 'Achieved compliance with all regulatory requirements efficiently']
  }, {
    title: 'Sr. Project Controls Specialist (FLUOR & Phoenix JV)',
    period: 'May 2007 — Nov 2007',
    description: 'Oversaw schedule and controls for World Trade Center HUB Redevelopment. Supported change management and claims analysis. Managed contract packaging and procurement processes. Ensured project controls aligned with Port Authority of NY objectives.',
    achievements: ['Delivered comprehensive schedule updates to stakeholders', 'Facilitated contract packaging for procurement efficiency', 'Analysed claims to mitigate financial risks', 'Enhanced project controls to support strategic goals']
  }]
}, {
  company: 'POWER Engineers, Inc.',
  location: 'Bethel/Norwalk, CT',
  initial: 'P',
  logo: 'https://www.google.com/s2/favicons?domain=powereng.com&sz=128',
  fallbackLogo: 'https://logo.clearbit.com/powereng.com',
  roles: [{
    title: 'Schedule Engineer',
    period: 'Jun 2005 — Oct 2006',
    description: 'Oversaw electrical design and construction management for Eversource Bethel - Norwalk transmission program. Developed and implemented CPM schedules, coordinated daily and weekly progress reports, and established policies for P3 5.0 submittals, productivity models, and EVM reports.',
    achievements: ['Spearheaded CPM schedule implementation', 'Organised consolidation of construction progress reports', 'Analyzed and set policies for EVM reporting', 'Developed productivity models for project efficiency']
  }]
}, {
  company: 'Fitch Ratings Services',
  location: 'New York, NY',
  initial: 'F',
  logo: 'https://www.google.com/s2/favicons?domain=fitchratings.com&sz=128',
  fallbackLogo: 'https://logo.clearbit.com/fitchratings.com',
  roles: [{
    title: 'Financial Analyst',
    period: 'Jan 2004 — May 2005',
    description: 'Conduct reconciliation and analysis of processes, allocations, revenue, aging, and costs. Ensure compliance with SOX and GAAP standards and finance activities.',
    achievements: ['Developed accurate budget forecasts to guide financial planning', 'Analyzed cost and revenue data to identify trends and efficiencies', 'Enhanced reporting processes for improved financial oversight']
  }]
}, {
  company: 'National System of Care Services',
  location: 'Northern New Jersey',
  initial: 'N',
  logo: '',
  fallbackLogo: '',
  roles: [{
    title: 'Financial Controls Consultant',
    period: 'Jan 2004 — May 2005',
    description: 'Developed comprehensive financial management and control Excel model for National System of Care. Designed multi-tiered integrated workbook with 350+ sheets, detailing balance sheet, cost, and revenue models by location and service. Streamlined budget, forecast, and actual financial reporting processes.',
    achievements: ['Engineered financial models for accurate forecasting and budgeting', 'Organised data for 350+ locations and services, enhancing accessibility', 'Improved reporting efficiency, facilitating timely financial insights']
  }]
}, {
  company: 'AIG Insurance',
  location: 'New York, NY',
  initial: 'A',
  logo: 'https://www.google.com/s2/favicons?domain=aig.com&sz=128',
  fallbackLogo: 'https://logo.clearbit.com/aig.com',
  roles: [{
    title: 'Project Scheduler',
    period: 'Jan 2000 — Jan 2001',
    description: 'Develop and implement project-level SDLC schedule solutions. Create detailed integrated project plans, apply CPM logic, and manage resource planning. Track progress and report using MS Project, integrating content management systems and workflows with Vignette, WebSphere, and .NET.',
    achievements: ['Designed comprehensive project schedules for multiple initiatives', 'Streamlined resource allocation, enhancing project efficiency', 'Improved reporting accuracy through effective use of MS Project', 'Facilitated collaboration among cross-functional teams']
  }]
}, {
  company: 'Merrill Lynch',
  location: 'New York, NY',
  initial: 'M',
  logo: 'https://www.google.com/s2/favicons?domain=ml.com&sz=128',
  fallbackLogo: 'https://logo.clearbit.com/ml.com',
  roles: [{
    title: 'PMO Scheduler',
    period: 'Jan 2000 — Jan 2001',
    description: 'Oversee global PMO for PMAC data warehouse accounting system. Ensure schedule maintenance and develop comprehensive weekly progress reports. Collaborate with cross-functional teams to enhance project planning.',
    achievements: ['Delivered timely schedule updates to stakeholders', 'Developed detailed PMO reports for executive review', 'Facilitated communication between project teams and management']
  }]
}, {
  company: 'Uproar.com',
  location: 'New York, NY',
  initial: 'U',
  logo: '',
  fallbackLogo: '',
  roles: [{
    title: 'Project Scheduler',
    period: 'Jan 2000 — Jan 2001',
    description: 'Designed SDLC implementation in MS Project for 80 diverse projects. Utilised CPM methodology for resource planning and dynamic reporting. Managed development stages effectively, ensuring alignment with pre-Yahoo merger objectives.',
    achievements: ['Developed project timelines and resource allocation strategies', 'Enhanced reporting accuracy through dynamic metrics', 'Collaborated with cross-functional teams to streamline project progress']
  }]
}, {
  company: 'National Network Technologies',
  location: 'Greater New York Area',
  initial: 'N',
  logo: '',
  fallbackLogo: '',
  roles: [{
    title: 'Project Controls Manager',
    period: 'Aug 1999 — Oct 1999',
    description: 'Oversee project tracking, budgeting, and job costing within PMO. Enhance business processes to streamline project controls and ensure compliance of multiple subcontractor activities with plans and budgets. Manage early-phase construction of fibre networks for Level 3 Communications.',
    achievements: ['Improved project tracking processes, increasing efficiency by 20%', 'Streamlined compliance monitoring procedures for subcontractor activities', 'Managed budgets for multiple projects, ensuring on-time delivery within financial constraints']
  }]
}, {
  company: 'Quest Real Estate',
  location: 'New York, NY',
  initial: 'Q',
  logo: '',
  fallbackLogo: '',
  roles: [{
    title: 'Licensed Real Estate Agent',
    period: 'Feb 1999 — Aug 1999',
    description: 'Facilitated apartment rentals as a licensed real estate agent in New York. Managed property listings, conducted market analyses, and coordinated client viewings. Developed strong relationships with landlords and tenants to ensure successful transactions.',
    achievements: ['Drove property visibility through strategic marketing initiatives', 'Championed client satisfaction by providing tailored rental solutions', 'Streamlined leasing processes, reducing turnaround time for listings']
  }]
}, {
  company: 'Skanska – Barney',
  location: 'New York, NY',
  initial: 'S',
  logo: 'https://www.google.com/s2/favicons?domain=skanska.com&sz=128',
  fallbackLogo: 'https://logo.clearbit.com/skanska.com',
  roles: [{
    title: 'Assistant Scheduler',
    period: 'Jan 1998 — Feb 1999',
    description: 'Assisted in centralized scheduling for construction projects using Primavera Project Planner (P3). Developed and maintained site-specific work plans, proposal, estimation, and forensic schedules for projects valued at $160 million. Ensured alignment with project timelines and stakeholder needs.',
    achievements: ['Collaborated with project teams to streamline scheduling processes', 'Monitored project progress and adjusted schedules as necessary', 'Provided analytical support for project estimation and proposal phases']
  }]
}, {
  company: 'Lehman Brothers',
  location: 'New York, NY',
  initial: 'L',
  logo: '',
  fallbackLogo: '',
  roles: [{
    title: 'Accounting Analyst',
    period: 'Sep 1998 — Oct 1998',
    description: 'Oversaw mortgage market transaction tracking and maintained detailed Excel spreadsheets. Ensured accuracy of financial data and provided insights for decision-making.',
    achievements: ['Streamlined reporting processes, enhancing efficiency by 20%', 'Collaborated with cross-functional teams to align financial strategies', 'Trained junior analysts on spreadsheet management techniques']
  }]
}, {
  company: 'Laidlaw & Company',
  location: 'New York, NY',
  initial: 'L',
  logo: '',
  fallbackLogo: '',
  roles: [{
    title: 'Intern',
    period: 'Jul 1998 — Aug 1998',
    description: 'Conducted reviews of financial investments and proposals. Shadowed board member for insights into strategic decision-making. Engaged in practical learning over a 3-week internship.',
    achievements: ['Analyzed investment opportunities for potential growth', 'Assisted in preparing presentations for board discussions', 'Gained exposure to corporate finance practices']
  }]
}, {
  company: 'Program Planning Professionals & Ford Motor Co.',
  location: 'Dearborn, MI',
  initial: 'P',
  logo: 'https://www.google.com/s2/favicons?domain=ford.com&sz=128',
  fallbackLogo: 'https://logo.clearbit.com/ford.com',
  roles: [{
    title: 'Project Management Consultant Analyst',
    period: 'Oct 1997 — Jul 1998',
    description: 'Developed detailed Critical Path Method (CPM) schedules and enhanced processes. Facilitated Project Management Office (PMO) activities and central reporting functions. Conducted analysis and generated comprehensive reports using Primavera P3 2.0, Excel, Oracle DB, and web reporting tools.',
    achievements: ['Created and maintained work breakdown structures (WBS)', 'Improved reporting efficiency through process enhancements', 'Assisted in project tracking and performance analysis', 'Streamlined communication across project teams']
  }]
}];
export function ExperienceSection() {
  return <section id="experience" className="py-20 bg-[#FDFBF7]" data-id="element-136">
      <div className="max-w-4xl mx-auto px-6 md:px-12" data-id="element-137">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-138">
          <h2 className="text-2xl md:text-3xl font-bold text-corporate-blue mb-4" data-id="element-139">
            Professional Experience
          </h2>
          <p className="text-[#6B6356] text-sm" data-id="element-140">
            A timeline of impact and leadership across industry-leading
            organizations.
          </p>
        </motion.div>

        <div className="space-y-10" data-id="element-141">
          {experienceData.map((group, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="relative" data-id="element-142">
              {/* Company Header */}
              <div className="flex items-center mb-5" data-id="element-143">
                <div className="w-12 h-12 bg-corporate-gray rounded-xl flex items-center justify-center text-lg font-bold text-corporate-blue mr-4 shadow-sm border border-[#E8E0D0] flex-shrink-0 overflow-hidden p-1.5" data-id="element-144">
                  {group.logo ? <img src={group.logo} alt={`${group.company} logo`} className="w-full h-full object-contain" onError={e => {
                const target = e.target as HTMLImageElement;
                if (group.fallbackLogo && target.src !== group.fallbackLogo) {
                  target.src = group.fallbackLogo;
                } else {
                  target.style.display = 'none';
                  const parent = target.parentElement;
                  if (parent) {
                    parent.innerHTML = `<span class="text-lg font-bold text-corporate-blue">${group.initial}</span>`;
                  }
                }
              }} data-id="element-145" /> : <span data-id="element-146">{group.initial}</span>}
                </div>
                <div data-id="element-147">
                  <h3 className="text-lg md:text-xl font-bold text-corporate-blue" data-id="element-148">
                    {group.company}
                  </h3>
                  <div className="flex items-center text-[#7A7062] text-xs mt-1" data-id="element-149">
                    <MapPin size={14} className="mr-1" data-id="element-150" />
                    {group.location}
                  </div>
                </div>
              </div>

              {/* Roles */}
              <div className="ml-6 pl-7 border-l-2 border-[#E8E0D0] space-y-7 pb-2" data-id="element-151">
                {group.roles.map((role, rIndex) => <div key={rIndex} className="relative" data-id="element-152">
                    {/* Timeline Dot */}
                    <div className="absolute -left-[39px] top-1.5 w-4 h-4 bg-[#FDFBF7] border-4 border-corporate-teal rounded-full" data-id="element-153"></div>

                    <h4 className="text-base md:text-lg font-bold text-[#1E293B] mb-1" data-id="element-154">
                      {role.title}
                    </h4>
                    <span className="inline-block px-3 py-1 bg-corporate-blue/5 text-corporate-blue text-xs font-semibold rounded-full mb-3" data-id="element-155">
                      {role.period}
                    </span>
                    <p className="text-[#6B6356] leading-relaxed mb-3 text-sm" data-id="element-156">
                      {role.description}
                    </p>

                    {/* Achievements Bullets */}
                    {role.achievements && role.achievements.length > 0 && <ul className="space-y-2 mt-3" data-id="element-157">
                        {role.achievements.map((achievement, aIndex) => <li key={aIndex} className="flex items-start text-[#6B6356] text-xs md:text-sm" data-id="element-158">
                            <span className="mr-3 mt-2 w-1.5 h-1.5 bg-corporate-teal rounded-full flex-shrink-0" data-id="element-159"></span>
                            <span className="leading-relaxed" data-id="element-160">
                              {achievement}
                            </span>
                          </li>)}
                      </ul>}
                  </div>)}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}